"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var make_cancelable_promise_1 = require("../../../../utils/make-cancelable-promise");
var AccessibleSocialButton = /** @class */ (function (_super) {
    tslib_1.__extends(AccessibleSocialButton, _super);
    function AccessibleSocialButton(props) {
        var _this = _super.call(this, props) || this;
        _this.setAccessibilityStatus = function (isAccessible) {
            if (!_this.iframeNode) {
                return;
            }
            _this.iframeNode.setAttribute('tabindex', isAccessible ? 0 : -1);
            if (isAccessible) {
                _this.iframeNode.removeAttribute('aria-hidden');
                return;
            }
            _this.iframeNode.setAttribute('aria-hidden', true);
        };
        _this.saveContainerNode = function (node) {
            _this.containerNode = node;
        };
        _this.attachScriptPromise = null;
        return _this;
    }
    AccessibleSocialButton.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, attachScript = _a.attachScript, initButton = _a.initButton, title = _a.title;
        this.attachScriptPromise = (0, make_cancelable_promise_1.makeCancelable)(attachScript());
        this.attachScriptPromise.promise
            .then(function () { return initButton(_this.containerNode); })
            .then(function () {
            _this.iframeNode = _this.containerNode.querySelector('iframe');
            _this.setAccessibilityStatus(_this.props.isAccessible);
            if (title) {
                _this.iframeNode.setAttribute('title', title);
            }
        });
    };
    AccessibleSocialButton.prototype.componentWillUnmount = function () {
        this.attachScriptPromise.cancel();
    };
    AccessibleSocialButton.prototype.UNSAFE_componentWillReceiveProps = function (_a) {
        var isAccessible = _a.isAccessible;
        if (isAccessible !== this.props.isAccessible && this.iframeNode) {
            this.setAccessibilityStatus(isAccessible);
        }
    };
    AccessibleSocialButton.prototype.render = function () {
        var children = this.props.children;
        return react_1.default.createElement("div", { ref: this.saveContainerNode }, children);
    };
    AccessibleSocialButton.propTypes = {
        isAccessible: prop_types_1.default.bool,
        attachScript: prop_types_1.default.func,
        initButton: prop_types_1.default.func,
        children: prop_types_1.default.node,
        title: prop_types_1.default.string,
    };
    return AccessibleSocialButton;
}(react_1.default.Component));
exports.default = AccessibleSocialButton;
//# sourceMappingURL=accessible-social-button.js.map